import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'dva-toolbar-progress',
  templateUrl: './toolbar-progress.component.html',
  styleUrls: ['./toolbar-progress.component.scss'],
})
export class ToolbarProgressComponent {
  @Output() openProgressPanel = new EventEmitter();

  constructor() {}
}
